import { formatBytes, formatDate } from "../../i18n/format.ts";
import { currentLocale } from "../../i18n/i18n.ts";

export { formatBytes, formatDate };

/** A count or sum in the interface language: "1,234", "1 234". */
export function formatNumber(value: number, maximumFractionDigits = 0): string {
  return new Intl.NumberFormat(currentLocale(), { maximumFractionDigits }).format(value);
}

/** A share in [0, 1] as a percentage with at most one decimal: "12.5%", "12,5 %". */
export function formatPercent(share: number): string {
  return new Intl.NumberFormat(currentLocale(), {
    style: "percent",
    maximumFractionDigits: 1,
  }).format(share);
}

/** An estimated cost in US dollars: "$41.00", "41,00 $US". Small amounts keep cents. */
export function formatUsd(value: number): string {
  return new Intl.NumberFormat(currentLocale(), {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: value !== 0 && Math.abs(value) < 1 ? 4 : 2,
  }).format(value);
}

/** A day on an axis, without the year: "20 Oct", "20 oct.". Takes `YYYY-MM-DD` or ISO. */
export function formatDay(iso: string): string {
  return new Intl.DateTimeFormat(currentLocale(), {
    day: "numeric",
    month: "short",
    timeZone: "UTC",
  }).format(new Date(iso.length === 10 ? `${iso}T00:00:00Z` : iso));
}
